import SettingsSvg from 'assets/icons/navigation/settings.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(SettingsSvg, {
  displayName: 'SettingsIcon',
});
